import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-common-table-paging',
	templateUrl: './common-table-paging.component.html',
	styleUrls: ['./common-table-paging.component.css']
})
export class CommonTablePagingComponent implements OnInit {

	@Input() isPaging? = true;
	@Input() totalNum: number; // When (and only when) totalNum is null, display ? for totalNum
	@Input() currentRowNum: number;
	@Input() pageSize: number;
	@Input() footerHeight = 30;
	@Input() sampleData: boolean;
	@Output() paging: EventEmitter<number> = new EventEmitter();
	@Output() requestTotal: EventEmitter<any> = new EventEmitter();
	public fromNum = 1;
	public toNum: number;
	public pageNum  = 1;
	constructor() { }

	goFirstPage() {
		if (this.pageNum !== 1) {
			this.pageNum = 1;
			this.fromNum = 1;
			this.toNum = this.pageSize;
			this.paging.emit(this.pageNum);
		}
	}
	goLastPage() {
		if (this.pageNum !== Math.ceil(this.totalNum / this.pageSize)) {
			this.pageNum = Math.ceil(this.totalNum / this.pageSize);
			this.fromNum = this.pageSize * (this.pageNum - 1) + 1;
			this.toNum = this.totalNum;
			this.paging.emit(this.pageNum);
		}
	}
	goPage() {
		this.fromNum = this.pageSize * (this.pageNum - 1) + 1;
		this.toNum = this.pageSize * this.pageNum;
		this.paging.emit(this.pageNum);
	}
	goPreviousPage() {
		if (this.pageNum > 1) {
			this.pageNum -= 1;
			// to the first page
			if (this.fromNum - this.pageSize < 1) {
				this.fromNum = 1;
				this.toNum = this.pageSize;
			} else {
				this.fromNum -= this.pageSize;
				this.toNum = this.fromNum + this.pageSize - 1;
			}
			this.paging.emit(this.pageNum);
		}
	}
	goNextPage() {
		if (this.totalNum > this.toNum) {
			this.pageNum += 1;
			// to the last page
			if (this.toNum + this.pageSize > this.totalNum) {
				this.toNum = this.totalNum;
			} else {
				this.toNum = this.toNum + this.pageSize;
			}
			this.fromNum += this.pageSize;
			this.paging.emit(this.pageNum);
		}
	}
	changePageNum() {
		if (this.pageNum < 1) {
			this.goFirstPage();
		} else if (this.pageNum > Math.ceil(this.totalNum / this.pageSize)) {
			this.goLastPage();
		} else {
			this.goPage();
		}
	}
	reset(pageNum, totalNum) {
		this.pageNum = pageNum;
		this.totalNum = totalNum;
		this.fromNum = (this.pageNum - 1) * this.pageSize + 1;
		// this.toNum = (this.pageNum - 1) * this.pageSize + this.currentRowNum;
		this.toNum = this.pageNum * this.pageSize > this.totalNum ? this.totalNum : this.pageNum * this.pageSize;
		// this.pageNum * this.pageSize > this.totalNum ? this.totalNum : this.pageNum * this.pageSize;
		// When the records number is less than a page size, use the number as total counts
		if (this.toNum < this.pageSize) {
			this.totalNum = this.toNum;
		}
	}

	ngOnInit() {
		this.toNum = this.fromNum + this.pageSize - 1;
		// this.totalNum = this.totalNum || 0;
		// if (this.toNum > this.totalNum) {
		// 	this.toNum = this.totalNum;
		// }
	}

}
